/** Pastille de présence : vert = en ligne (activité < 5 min), rouge = hors ligne. */
export const PastilleEnLigne = ({ enLigne, avecTexte = false, testid }) => (
  <span
    className="inline-flex items-center gap-1.5"
    title={enLigne ? "Annonceur en ligne" : "Annonceur hors ligne"}
    data-testid={testid || `pastille-${enLigne ? "en-ligne" : "hors-ligne"}`}
  >
    <span className="relative flex h-2.5 w-2.5 shrink-0">
      {enLigne && (
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-70" />
      )}
      <span
        className={`relative inline-flex h-2.5 w-2.5 rounded-full ring-2 ring-white ${
          enLigne ? "bg-emerald-500" : "bg-red-500"
        }`}
      />
    </span>
    {avecTexte && (
      <span className={`text-[11px] font-bold uppercase tracking-wide ${
        enLigne ? "text-emerald-700" : "text-red-600"
      }`}>
        {enLigne ? "En ligne" : "Hors ligne"}
      </span>
    )}
  </span>
);
